import httpService from '../httpService';
import { ApiResponse } from '../../types/api';

export async function del<T>(url: string): Promise<ApiResponse<T>> {
  const response = await httpService.delete<ApiResponse<T>>(url);
  return response.data;
}
